import { type FC } from "react";
import { IoIosClose } from "react-icons/io";
import { TablaCierresCaja } from "./TablaCierresCaja";
import type { TablaCierresCajaModalProps } from "../types";

export const TablaCierresCajaModal: FC<TablaCierresCajaModalProps> = ({
  formatDate,
  onClose,
  usuarioRuta,
}) => {
  return (
    <div className="w-full min-h-screen h-screen z-40 bg-black bg-opacity-50 px-2 md:px-8 flex justify-center items-center fixed top-0 left-0">
      <div className="bg-gray-200 w-[400px] md:w-full py-4 px-1 rounded-md relative max-h-[90%] overflow-y-auto">
        <IoIosClose
          className="absolute right-0 top-0 cursor-pointer"
          size={40}
          onClick={onClose}
        />
        <span className="font-bold text-lg ml-2">Cierres de caja</span>

        <div className="w-full overflow-x-auto py-2">
          <TablaCierresCaja formatDate={formatDate} usuarioRuta={usuarioRuta} />
        </div>
      </div>
    </div>
  );
};
